import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles, Item } from './index';
import { formatShortDate } from '../../utils/date';
import {
  checkValidationBasedOnDate,
  currencyConversion,
  displayEqualizationAmount,
} from '../../utils/utilityFunctions';
import {
  EqualizationAmountValidationDate,
  IS_ONLINE_PAYMENT_APPLICABLE_FOR_AMC,
  PaymentModeMaster,
  YES_NO_BOOLEAN_MASTER,
} from '../../utils/constant';

export default function InvestAndPaymentDetails({
  application,
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Investment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue
                  title={'Accredited Investor'}
                  description={
                    YES_NO_BOOLEAN_MASTER[application.isAccreditedInvestor?.toString() || '']
                  }
                />
                <KeyValue
                  title={'Group Investment'}
                  description={
                    YES_NO_BOOLEAN_MASTER[application?.groupInvestment?.toString() || '']
                  }
                />
                {application.groupInvestment && (
                  <KeyValue title={'Group Name'} description={application.groupName} />
                )}
                <KeyValue title={'Fund (Scheme)'} description={application.scheme?.schemeName} />
                <KeyValue title={'Class Plan'} description={application.plan?.planDescription} />
                <KeyValue
                  title={'Commitment Amount (INR)'}
                  description={application.commitmentAmount}
                  amount={currencyConversion(application.commitmentAmount)}
                />
                <KeyValue
                  title={'Management Fees Rate'}
                  description={application.managementFeesRate}
                />
                {/* <KeyValue title={'Tax Rate'} description={application.taxRate} /> */}
                {/* <KeyValue title={'DrawDown Number'} description={application.drawDownNumber} /> */}
                <KeyValue
                  title={'Initial Contribution Amount (INR)'}
                  description={application.contributionChequeAmount}
                  amount={currencyConversion(application.contributionChequeAmount)}
                />
                <KeyValue
                  title={'Setup Fee Percentage'}
                  description={application.setupFeePercentage}
                />
                <KeyValue
                  title={'Setup Fee Amount'}
                  description={application.setupFeeAmount}
                  amount={currencyConversion(application.setupFeeAmount)}
                />
                <KeyValue
                  title={'GST (GST On Setup Fee Amount)'}
                  description={application.setupFeeGST}
                  amount={currencyConversion(application.setupFeeGST)}
                />
                <KeyValue
                  title={'Total Setup Fee'}
                  description={application.totalSetupFee}
                  amount={currencyConversion(application.totalSetupFee)}
                />
                <KeyValue
                  title={'TDS'}
                  description={application.setupFeeTDS}
                  amount={currencyConversion(application.setupFeeTDS)}
                />
                <KeyValue
                  title={'Setup Fee Payable'}
                  description={application.netSetupFeeLessTDS}
                  amount={currencyConversion(application.netSetupFeeLessTDS)}
                />
                {displayEqualizationAmount(
                  application.plan?.schemeCategory as string,
                  application.scheme?.schemeCode as string
                ) &&
                  (checkValidationBasedOnDate(
                    application.createdAt || '',
                    EqualizationAmountValidationDate
                  ) ? (
                    <KeyValue
                      title={'Equalization Amount Per Crore'}
                      description={application.equalizationAmountPerCr}
                      amount={currencyConversion(application.equalizationAmountPerCr)}
                    />
                  ) : (
                    <KeyValue
                      title={'Equalization Amount'}
                      description={application.equalizationAmount}
                      amount={currencyConversion(application.equalizationAmount)}
                    />
                  ))}
                <KeyValue
                  title={'Total Amount Payable'}
                  description={application.totalAmountPayable}
                  amount={currencyConversion(application.totalAmountPayable)}
                />
                {IS_ONLINE_PAYMENT_APPLICABLE_FOR_AMC && (
                  <KeyValue
                    title={'Payment Type'}
                    description={PaymentModeMaster[application.paymentMode as string]}
                  />
                )}
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Fund Bank Account Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                pb={5}
                rowSpacing={6}
                columnSpacing={15}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Bank Name'} description={application.scheme?.bankName} />
                <KeyValue
                  title={'Bank Account Number'}
                  description={application.scheme?.bankAccountNumber}
                />
                <KeyValue title={'IFSC Code'} description={application.scheme?.ifscCode} />
                <KeyValue title={'Bank Branch'} description={application.scheme?.bankBranch} />
                <KeyValue title={'Bank Address'} description={application.scheme?.bankAddress} />
                <KeyValue title={'MICR Code'} description={application.scheme?.micrCode} />
                <KeyValue
                  title={'Bank Account Type'}
                  description={application.scheme?.bankAccountType}
                />
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
